import React, { ReactElement } from 'react';
import classNames from 'classnames';

import CommonPicture from 'src/components/Common/Picture';

import * as styles from './Picture.module.css';

export const ImagePositionOptions = ['left', 'centered', 'right'] as const;
type ImagePosition = typeof ImagePositionOptions[number];

interface PictureProps {
  /** HTML alt text */
  alt: string;
  /** HTML figcaption string */
  caption?: string;
  /** CSS class name */
  className?: string | string[];
  /** image (imported) if set src is not needed */
  image?: string;
  /** vertical image position */
  position?: ImagePosition;
  /**
   * @deprecated use image property
   */
  src?: string;
  /** HTML title text */
  title?: string;
}

/** renders figure tag */
const Picture = ({
  alt,
  caption,
  className,
  image,
  position,
  src,
  title,
}: PictureProps): ReactElement => (
  <figure
    className={classNames(styles.cePicture, 'ce', styles[position], className)}
  >
    <CommonPicture src={src} image={image} alt={alt} title={title} />
    {caption && <figcaption>{caption}</figcaption>}
  </figure>
);

Picture.defaultProps = {
  caption: null,
  className: null,
  image: null,
  position: 'left',
  src: null,
  title: '',
};

export default Picture;
